
export const SAVE_PROFIL = 'save_profil';

export function saveProfilAction(user){
  return {
    type: SAVE_PROFIL,
    user: user
  }
}
